import { Component, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { EnaioCertificateService } from '../../services/enaio-certificate.service';
import { ClassRegister } from '../../shared/class-register.entity';
import { CourseParticipantDto } from '../../shared/course-participant.dto';
import { MissDayDto } from '../../shared/miss-day.dto';
import { Pupil } from '../../shared/pupil.model';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';

@Component({
  selector: 'app-class-pupils',
  templateUrl: './class-pupils.component.html',
  styleUrls: ['./class-pupils.component.scss']
})
export class ClassPupilsComponent extends ComponentView {

    service = inject(EnaioCertificateService);

    neededParams: ObjectOfSimpleDataTypes = { id: "number" };
    id: number;

    classRegister: ClassRegister;
    pupils: Pupil[];
    courses: CourseParticipantDto[];
    missDays: MissDayDto[];
    table: TableData;

    override async initParams(): Promise<boolean> {
        this.classRegister = await this.service.restGetClassRegister(this.id, null, null, true);
        this.pupils = await this.service.restGetPupils(this.classRegister.schoolClassId);
        this.courses = this.pupils.length == 0 ? [] : await RestEndpoint.main().query({year: this.classRegister.enaioSchoolClass.getYearNumber(), isHalfYear: this.classRegister.isHalfYear, pupilIds: Utils.arrayItemsToString(this.pupils, ",", p => Utils.toString(p.id))}).run("api/cer/classregister/coursesforpupils").list(CourseParticipantDto);
        this.missDays = await RestEndpoint.main().query({id: this.id}).run("api/cer/classregister/missdays").list(MissDayDto);

        this.table = new TableData([
            new TableColumn("lastName", "Nachname", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("firstName", "Vorname", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("birthday", "Geburtsdatum", TableCellType.date, { autoWidth: 1 }),
            new TableColumn("street", "Straße", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("houseNumber", "Hausnummer", TableCellType.text, { autoWidth: 7 }),
            new TableColumn("zipCode", "PLZ", TableCellType.text, { autoWidth: 5 }),
            new TableColumn("city", "Ort", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("custodian1", "Sorgeberechtigter 1", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("custodian2", "Sorgeberechtigter 2", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("therapies", "Therapien", TableCellType.text, { autoWidth: 50, editable: true, editableMaxLength: 100 }),
            new TableColumn("courses", "Kurse", TableCellType.text, { autoWidth: 50 }),
            this.classRegister.enaioSchoolClass.getUseAfterSchoolCenter() ? new TableColumn("afterSchoolCenter", "Hort", TableCellType.yesNo, { autoWidth: 1 }) : null,
            new TableColumn("missDaysExcused", "Fehltage ent.", TableCellType.int, { autoWidth: 2 }),
            new TableColumn("missDaysUnexcused", "Fehltage unent.", TableCellType.int, { autoWidth: 2 })
        ], this.pupils.map(item => new TableRow("", item, {
            lastName: item.lastName,
            firstName: item.firstName,
            birthday: item.birthday,
            street: item.street,
            houseNumber: item.houseNumber,
            zipCode: item.zipCode,
            city: item.city,
            custodian1: Utils.stringCombine(item.custodian1Phone, item.custodian1Mail, " / "),
            custodian2: Utils.stringCombine(item.custodian2Phone, item.custodian2Mail, " / "),
            therapies: item.therapies,
            courses: Utils.arrayItemsToString(this.courses.filter(c => c.pupilId == item.id), ", ", c => c.courseName),
            afterSchoolCenter: item.afterSchoolCenter,
            missDaysExcused: Math.floor(this.missDays.filter(md => md.pupilId == item.id && md.excused).reduce((p, c) => p + c.getNumDays(), 0)),
            missDaysUnexcused: Math.floor(this.missDays.filter(md => md.pupilId == item.id && !md.excused).reduce((p, c) => p + c.getNumDays(), 0))
        })), [new TableSortColumn("lastName"), new TableSortColumn("firstName")]);

        await this.service.updateNavigationClassRegister(this.id, [
            { label: "Schülerverzeichnis", routerLink: ["/enaio-certificates", "class-registers", "pupils", this.id] }
        ]);
        return true;
    }

    override getCanDeactivateMessage(): string {
        return this.isChanged() ? "" : null;
    }

    isChanged(): boolean {
        return this.table.rows.find(row => (row.raw as Pupil).therapies != row.values.therapies) != null;
    }

    async save(): Promise<void> {
        let changed = this.table.rows.filter(row => (row.raw as Pupil).therapies != row.values.therapies);
        await this.app.saveDataHandler(async () => Promise.all(changed.map(async row => RestEndpoint.main().post().query({ id: (row.raw as Pupil).id, value: row.values.therapies}).run("api/cer/classregister/pupiltherapies").getText())), this, true, true);

    }

}
